<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h5>Address</h5>
      <vs-tooltip text="Add" color="primary" v-if="checkEditPermission && havePermission">
        <vs-button @click="handleAddPopUp()" type="border" icon="add" />
      </vs-tooltip>
    </div>
    <div class="table-responsive">
      <table class="light_blue_table w-full">
        <tbody>
          <tr v-for="(address, index) in addressProps" :key="index">
            <td>
              <div class="flex items-center">
                <span class="material-icons-outlined small_icon">place</span>
              </div>
            </td>
            <td>
              {{ address.address1 ? address.address1 : ""
              }}{{ address.address2 ? "," + address.address2 : "" }}
              {{ address.city ? "," + address.city : "" }}
              {{ address.state ? "," + address.state : "" }}
              {{ address.zip ? address.zip : ""
              }}{{
                address.platform_customer_countries_id
                  ? "," + getCountry(address.platform_customer_countries_id)
                  : ""
              }}
            </td>
            <td>
              <vs-checkbox
                :checked="address.defaults"
                @change="handlechange(index)"
                >Default</vs-checkbox
              >
            </td>
            <td class="text-right">
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="handleedit(index)"
                  >
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-if="checkDeletePermission && havePermission"
                    @click="showDeletePopUp(index)"
                  >
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete the address?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Add Address"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <template v-for="field in staticFields">
          <div v-if="['address1', 'address2', 'city', 'state', 'zip', 'platform_customer_countries_id'].includes(field.field_name)" class="p-1" :key="field.id">
            <div>
              <label class="vs-input--label w-full"
                >{{ field.field_label
                }}<span v-if="field.enabled_parent" class="required"></span
              ></label>
              <vs-input
                v-if="
                  field.field_name != 'platform_customer_countries_id' &&
                  field.field_name != 'platform_timezone_id' && field.field_name !=='dob'
                "
                v-validate="field.enabled_parent == true ? 'required' : ''"
                v-model="addressModalValue[field.field_name]"
                class="custom_Input"
                :name="field.field_label"
                style="width: 100%"
              />
            </div>
            <v-select
              v-if="
                field.field_name == 'platform_customer_countries_id' &&
                field.field_name != 'platform_timezone_id'
              "
              v-model="addressModalValue[field.field_name]"
              v-validate="field.enabled_parent == true ? 'required' : ''"
              :reduce="(option) => option.id"
              label="country_name"
              :name="field.field_label"
              :options="countryList"
              style="width: 100%"
            />
            <div
              class="flex items-center"
              style="color: rgba(var(--vs-primary), 1); font-size: 12px"
              v-if="field.field_label == 'Phone'"
            >
              <span
                style="font-size: 14px; margin-right: 2px"
                class="material-icons-outlined"
                >info</span
              >Country code is mandatory.
            </div>

            <span
              v-show="errors.has(`add.${field.field_label}`)"
              class="text-danger ss"
              >{{ errors.first(`add.${field.field_label}`) }}</span
            >
          </div>
        </template>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleAddCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Edit Address"
      :active.sync="editpopup"
    >
      <form data-vv-scope="edit">
        <template v-for="field in staticFields">
          <div v-if="['address1', 'address2', 'city', 'state', 'zip', 'platform_customer_countries_id'].includes(field.field_name)" class="p-1" :key="field.id">
            <div>
              <label class="vs-input--label w-full"
                >{{ field.field_label
                }}<span v-if="field.enabled_parent" class="required"></span
              ></label>
              <vs-input
                v-if="
                  field.field_name != 'platform_customer_countries_id' &&
                  field.field_name != 'platform_timezone_id' && field.field_name !=='dob'
                "
                v-validate="field.enabled_parent == true ? 'required' : ''"
                v-model="edit[field.field_name]"
                class="custom_Input"
                :name="field.field_label"
                style="width: 100%"
              />
            </div>
            <v-select
              v-if="
                field.field_name == 'platform_customer_countries_id' &&
                field.field_name != 'platform_timezone_id'
              "
              v-model="edit[field.field_name]"
              v-validate="field.enabled_parent == true ? 'required' : ''"
              :reduce="(option) => option.id"
              label="country_name"
              :name="field.field_label"
              :options="countryList"
              style="width: 100%"
            />
            <div
              class="flex items-center"
              style="color: rgba(var(--vs-primary), 1); font-size: 12px"
              v-if="field.field_label == 'Phone'"
            >
              <span
                style="font-size: 14px; margin-right: 2px"
                class="material-icons-outlined"
                >info</span
              >Country code is mandatory.
            </div>

            <span
              v-show="errors.has(`add.${field.field_label}`)"
              class="text-danger ss"
              >{{ errors.first(`add.${field.field_label}`) }}</span
            >
          </div>
        </template>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { GetCountryList } from '@/api/common'
import { TeacherUpdate } from '@/api/teacher'
import { fetchCustomStaticFields } from '@/api/customfield'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

import vSelect from 'vue-select'
export default {
  name: 'address',
  components: {
    vSelect
  },
  props: {
    addressProps: {
      required: true,
      type: Array,
      default: () => []
    },
    teacherPersonalDetails: {
      required: false,
      type: Object,
      default: () => {}
    },
    havePermission:{
      default: false
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  data () {
    return {
      countryList: [],
      staticFields: [],
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      addressModalValue: {
        address1: '',
        address2: '',
        city: '',
        id: '',
        state: '',
        zip: '',
        defaults: 0,
        platform_customer_countries_id: null
      },
      edit: {
        address1: '',
        address2: '',
        city: '',
        id: '',
        state: '',
        zip: '',
        defaults: 0
      },
      editIndex: null,
      deleteindex: false,
      addressAvailability: []
    }
  },
  watch: {
    addressProps: {
      deep: true,
      immediate: true,
      handler () {
        this.addressAvailability = this._.cloneDeep(this.addressProps)
      }
    }
  },
  mounted () {
    this.fetchCountry()
    this.fetch_field_list()
  },
  methods: {
    handleAddPopUp () {
      if (this.teacherPersonalDetails.basic_details.active_user == 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as staff is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.addpopup = true
    },
    showDeletePopUp (index) {
      if (this.addressAvailability[index].defaults === 1) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Default address can\'t be deleted',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        })
        return false;
      }
      this.deletepopup = true
      this.deleteindex = index
    },
    viewAddress () {
      const addressArray = []
      this.addressProps.forEach((e) => {
        if (e.address1) {
          addressArray.push(e.address1)
        }
        if (e.address2) {
          addressArray.push(e.address2)
        }
        if (e.city) {
          addressArray.push(e.city)
        }
        if (e.state) {
          addressArray.push(e.state)
        }
        if (e.zip) {
          addressArray.push(e.zip)
        }
      })
      return addressArray.join(', ')
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {
        console.log(e)
      }
    },
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(4, customerId,  {table_name:'staff_list'})

        this.staticFields = data.data.module_fields
      } catch (e) {}
    },
    handlechange (index) {
      if (!this.havePermission) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Sorry! you don\'t have permission to perform this action',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false;
      }
      if (this.teacherPersonalDetails.basic_details.active_user == 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as staff is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.addressProps.map((item) => {
        item.defaults = 0
      })
      this.addressProps[index].defaults = 1
      console.log(this.addressProps[index])
      const payload = this.addressProps[index]
      this.addressAvailability = this.addressProps
      this.handleAdresssave()
    },
    handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = {
            address1: this.addressModalValue.address1,
            address2: this.addressModalValue.address2,
            city: this.addressModalValue.city,
            id: this.addressModalValue.id,
            state: this.addressModalValue.state,
            zip: this.addressModalValue.zip,
            platform_customer_countries_id:
              this.addressModalValue.platform_customer_countries_id,
            defaults: 0
          }
          this.addressAvailability.push(payload)
          this.handleAdresssave()
        }
      })
    },
    handleAddCancel () {
      this.addpopup = false
      this.addressModalValue = {
        address1: '',
        address2: '',
        city: '',
        id: '',
        state: '',
        zip: '',
        platform_customer_countries_id: null,
        defaults: 0
      }
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    handleDelete () {
      this.addressAvailability.splice(this.deleteindex, 1)
      this.handleAdresssave()
    },
    handleedit (index) {
      if (!this.havePermission || !this.checkEditPermission) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Sorry! you don\'t have permission to perform this action',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false;
      }
      if (this.teacherPersonalDetails.basic_details.active_user == 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as staff is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editpopup = true
      this.edit = this.addressAvailability[index]
      this.editIndex = index
    },
    handleUpdate () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.addressAvailability[this.editIndex] = this.edit
          this.handleAdresssave()
        }
      })
    },
    getCountry (id) {
      if (id) {
        const index = this.countryList.findIndex((item) => item.id === id)
        return this.countryList[index].country_name
      } else {
        return 'not available'
      }
    },
    async handleAdresssave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            address: this.addressAvailability
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )

        this.addpopup = false
        this.editpopup = false
        this.deletepopup = false

        this.addressModalValue = {
          address1: '',
          address2: '',
          city: '',
          id: '',
          state: '',
          zip: '',
          platform_customer_countries_id: null,
          defaults: 0
        }

        this.$emit('setAfterUpdate', data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
